import React, { useState, useCallback } from 'react';
import Banner from './Banner';

let notificationManagerInstance = null;

export default function ErrorBannerManager() {
  const [notifications, setNotifications] = useState([]);

  const addNotification = useCallback((notification, options = {}) => {
    const notificationId = Date.now() + Math.random();
    const newNotification = {
      id: notificationId,
      message: notification.message || notification,
      title: options.title || (options.type === 'success' ? 'Success' : 'Error'),
      type: options.type || 'error', // 'error', 'success'
      position: options.position || 'top-right',
      autoHide: options.autoHide !== false,
      autoHideDelay: options.autoHideDelay || (options.type === 'success' ? 4000 : 7000),
      ...options
    };

    setNotifications(prev => [...prev, newNotification]);
    return notificationId;
  }, []);

  const removeNotification = useCallback((notificationId) => {
    setNotifications(prev => prev.filter(notification => notification.id !== notificationId));
  }, []);

  const clearAllNotifications = useCallback(() => {
    setNotifications([]);
  }, []);

  // Store instance reference for external access
  React.useEffect(() => {
    notificationManagerInstance = {
      addNotification,
      removeNotification,
      clearAllNotifications
    };

    return () => {
      notificationManagerInstance = null;
    };
  }, [addNotification, removeNotification, clearAllNotifications]);

  return (
    <>
      {notifications.map((notification) => (
        <Banner
          key={notification.id}
          type={notification.type || 'info'}
          message={notification.message}
          title={notification.title}
          position={notification.position}
          autoHide={notification.autoHide}
          autoHideDelay={notification.autoHideDelay}
          action={notification.action}
          onClose={() => removeNotification(notification.id)}
        />
      ))}
    </>
  );
}

// Export functions to control notifications from anywhere in the app
export const showErrorBanner = (error, options = {}) => {
  if (notificationManagerInstance) {
    return notificationManagerInstance.addNotification(error, { ...options, type: 'error' });
  } else {
    console.error('NotificationManager not initialized. Error:', error);
    return null;
  }
};

export const showSuccessBanner = (success, options = {}) => {
  if (notificationManagerInstance) {
    return notificationManagerInstance.addNotification(success, { ...options, type: 'success' });
  } else {
    console.error('NotificationManager not initialized. Success:', success);
    return null;
  }
};

export const hideNotification = (notificationId) => {
  if (notificationManagerInstance) {
    notificationManagerInstance.removeNotification(notificationId);
  }
};

export const clearAllNotifications = () => {
  if (notificationManagerInstance) {
    notificationManagerInstance.clearAllNotifications();
  }
};

// Keep the old exports for backward compatibility
export const hideErrorBanner = hideNotification;
export const clearAllErrorBanners = clearAllNotifications; 